interface faqType {
    question: string,
    answer: string
}

export const faq: faqType[] = [
    {
        question: "Are you an esports team?",
        answer: "No, we are an agency for VTubers who are passionate about gaming. We welcome gamers of any genre of gaming (not just competitive titles)."
    },
    {
        question: "Can I bring my own model?",
        answer: "We prefer that you use a model provided by the company; however, if you believe your IP brings a lot to the table we’re willing to discuss using it."
    },
    {
        question: "Are you hiring outside of Canada?",
        answer: "We prefer candidates that are entitled to work in Canada or the United States, but we are willing to accept strong candidates from anywhere!"
    },
    {
        question: "Do I need prior streaming experience?",
        answer: "All applicants will be given a fair chance regardless of experience or popularity. But please keep in mind that VODs and videos that we can review will make you a stronger candidate."
    },
    {
        question: "Will you provide streaming equipment?",
        answer: "We can provide a microphone and a camera for tracking."
    },
    // {
    //     question: "Are auditions open right now?",
    //     answer: "Auditions are not open right now, please check our social media for updates."
    // },
    {
        question: "When will auditions close?",
        answer: "We are planning on closing auditions on April 13th at 11:59pm Eastern Standard Time."
    },
    {
        question: "If I audition, when will I hear back from you?",
        answer: "We will respond to all applicants. The very latest you can expect our response is when the talents have been decided."
    },
    {
        question: "Is there an age requirement?",
        answer: "Yes, we require that you are a legal adult of at least 18 years old to join."
    },
    {
        question: "Are you looking for sponsors?",
        answer: "Please direct all sponsor-related inquiries to management@nextgg.live"
    },
    {
        question: "Can male talents apply?",
        answer: "Anyone is welcome to apply! Please understand that male talents tend to have a harder time standing out. We recommend that you have a clever marketing strategy."
    },
    {
        question: "Can I apply if I’m not a native English speaker?",
        answer: "Absolutely! But because we focus on English-language streaming, we require that you are conversationally fluent in English (at least B2 level in the CEFR)."
    }
]